<template>
  <div v-if="parentEntity" class="mt-3">
    <right-panel class="float-right" id="sidebar-new-datasubject" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <right-panel class="float-right" id="sidebar-info-datasubject" width="800px">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("datasubject.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <h5>{{ $t("datasubject.used-places") }}</h5>
          <table v-if="info && info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("datasource.text") }}</th>
                <th>{{ $t("data.text") }}</th>
                <th class="text-center">{{ $t("common.edit") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.department.name | translate }}
                </td>
                <td>
                  {{ i.process.name | translate }}
                </td>
                <td>
                  {{ i.datasource.name | translate }}
                </td>
                <td>{{ i.name | translate }}</td>
                <td style="text-align: center;">
                  <a href="javascript:;void(0);" @click="deleteByIdFromHierarchy(i)" v-b-tooltip.hover :title="$t('common.delete')">
                    <i class="bx bx-trash-alt text-danger"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <!-- Begin: Pagination -->

        <div v-if="info" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
    </right-panel>

    <!-- Begin : Inventory -->
    <template>
      <right-panel class="float-right" id="sidebar-datasubject-inventory" width="1400px" icon="" @hidden="bulkUpdateRightPanelClosed">
        <b-tabs v-if="selectedBox" nav-class="nav-tabs-custom p-2 ml-3" v-model="activeTab" content-class="mt-1">
          <!-- BEGIN TAB-->
          <b-tab>
            <template v-slot:title>
              <span>
                {{ $t("inventory.filter.inventory-features") }}
              </span>
            </template>

            <div v-if="datasubjectInventory" class="pl-5 pr-5">
              <h3>{{ $t("datasubject.inventory", { datasubject: $options.filters.translate(selectedBox.name) }) }}</h3>

              <!--Processing-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.processing-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("processing.text") }}
                </h4>
                <b-collapse id="processing-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasubjectInventory.processingLegals || datasubjectInventory.processingLegals.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <b-row v-for="processingLegal in datasubjectInventory.processingLegals" :key="processingLegal._id" class="border-bottom border-gray pb-1 pt-1">
                      <b-col md="6">
                        <span class="text-danger hand hidden float-left" @click="deleteDatasubjectProcessingLegal(selectedBox._id, processingLegal._id)">
                          <i class="bx bx-trash"></i>
                        </span>

                        {{ processingLegal.purpose.name | translate }}
                        <span v-if="processingLegal.legitimateInterest" class="text-muted">
                          <br />
                          <b>{{ $t("processing-transfering.legitimate-interest.text") }}:</b>{{ processingLegal.legitimateInterest | translate }}
                        </span>
                      </b-col>
                      <b-col md="6">
                        {{ processingLegal.legalReason.name | translate }}
                        <span v-if="processingLegal.legalReason.regulation" class="text-muted">
                          <br />
                          <b>{{ $t("common.regulation") }}:</b>{{ processingLegal.legalReason.regulation | translate }}
                        </span>
                      </b-col>
                    </b-row>

                    <span class="text-primary hand hidden" @click="createDatasubjectProcessingLegal(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>

                    <span class="text-warning hand hidden ml-3" @click="editDatasubjectProcessingLegal(selectedBox, datasubjectInventory.processingLegals)">
                      <i class="bx bx-pencil"></i>
                    </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Transfering-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.transfering-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("transfering.text") }}
                </h4>
                <b-collapse id="transfering-accordion" class="border-top border-ligth" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasubjectInventory.transferings || datasubjectInventory.transferings.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <b-row style="font-weight: bold;">
                      <b-col>{{ $t("processing-transfering.purpose.text") }}</b-col>
                      <b-col>{{ $t("processing-transfering.reason-and-interest-alt") }}</b-col>
                      <b-col>{{ $t("transfering.method.text") }}</b-col>
                      <b-col>{{ $t("transfering.prevention.lean") }}</b-col>
                    </b-row>
                    <div v-for="transfering in datasubjectInventory.transferings" :key="transfering._id" class=" border-dark border p-1 mb-1">
                      <b-row>
                        <b-col>
                          <b>{{ transfering.thirdParty.name | translate }}</b>

                          <i v-if="transfering.thirdParty.country" class="text-muted">
                            ({{ transfering.thirdParty.country.code != currentOrganization.country.code ? $t("thirdparty.abroad") : $t("thirdparty.domestic") }})
                          </i>
                        </b-col>
                        <b-col>
                          <b>{{ transfering.thirdParty.receiverGroup.name | translate }} </b>

                          <span class="text-warning hand hidden float-right" @click="editDatasubjectTransfering(selectedBox, transfering)">
                            <i class="bx bx-pencil"></i> {{ $t("common.edit") }}
                          </span>

                          <span class="text-danger hand hidden float-right mr-2" @click="deleteDatasubjectTransfering(selectedBox._id, transfering._id)">
                            <i class="bx bx-trash"></i> {{ $t("common.delete") }}
                          </span>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col md="6">
                          <b-row
                            v-for="legal in transfering.legals"
                            :key="transfering.thirdParty._id + legal.legalReason.libraryItem._id + legal.purpose.libraryItem._id + selectedBox._id"
                            class="border-bottom border-gray pb-1 pt-1"
                          >
                            <b-col>
                              {{ legal.purpose.name | translate }}
                              <span v-if="legal.legitimateInterest" class="text-muted">
                                <br />
                                <b>{{ $t("processing-transfering.legitimate-interest.text") }}:</b>{{ legal.legitimateInterest | translate }}
                              </span>
                            </b-col>
                            <b-col>
                              {{ legal.legalReason.name | translate }}
                              <span v-if="legal.legalReason.regulation" class="text-muted">
                                <br />
                                <b>{{ $t("common.regulation") }}:</b>{{ legal.legalReason.regulation | translate }}
                              </span>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col>
                          <ul>
                            <li v-for="method in transfering.methods" :key="method._id + selectedBox._id">
                              {{ method.name | translate }}
                            </li>
                          </ul>
                        </b-col>
                        <b-col>
                          <ul>
                            <li v-for="prevention in transfering.preventions" :key="prevention._id + selectedBox._id">
                              {{ prevention.name | translate }}
                            </li>
                          </ul>
                        </b-col>
                      </b-row>
                    </div>

                    <span class="text-primary hand hidden" @click="createDatasubjectTransfering(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!--Datasubject Right-->
              <b-card no-body class="shadow-none mb-1">
                <h4 class="p-3 hand text-muted m-0" v-b-toggle.datasubject-right-accordion>
                  <span class="when-closed align-middle"> <i class="bx bx-chevron-right"></i> </span>
                  <span class="when-opened align-middle"> <i class="bx bx-chevron-down"></i> </span>
                  {{ $t("datasubject-right.text") }}
                </h4>
                <b-collapse id="datasubject-right-accordion" class="border-top border-light" :visible="false" accordion="accordion">
                  <b-card-body>
                    <empty v-if="!datasubjectInventory.datasubjectRights || datasubjectInventory.datasubjectRights.length == 0" width="100px">
                      <h5 class="text-center">
                        {{ $t("common.no-data") }}
                      </h5>
                    </empty>

                    <b-row v-for="datasubjectRight in datasubjectInventory.datasubjectRights" :key="datasubjectRight._id">
                      <b-col>
                        <i class="bx bx-trash text-danger hand hidden" @click="removeDatasubjectDatasubjectRigth(selectedBox._id, datasubjectRight._id)"></i>

                        {{ datasubjectRight.name | translate }}
                      </b-col>
                    </b-row>

                    <span class="text-primary hand" @click="addDatasubjectDatasubjectRight(selectedBox)"> <i class="bx bx-plus"></i> {{ $t("common.add") }} </span>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <content-loading v-if="isDatasubjectInventoryLoading" />
          </b-tab>

          <b-tab>
            <template v-slot:title>
              <span>
                {{ $t("inventory.bulk-update.text") }}
              </span>
            </template>

            <BulkUpdateView @onUpdated="onBulkUpdated" />
          </b-tab>
        </b-tabs>
      </right-panel>
      <template v-if="selectedBox">
        <right-panel class="float-right" id="sidebar-new-datasubject-transfering" width="1250px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasubjectTransferingForm id="sidebar-new-datasubject-transfering" />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasubject-processing-legal" width="1000px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasubjectProcessingLegalForm id="sidebar-new-datasubject-processing-legal" />
          </div>
        </right-panel>

        <right-panel class="float-right" id="sidebar-new-datasubject-datasubject-right" width="600px" @hidden="inventoryRightPanelClosed">
          <div class="pl-5 pr-5">
            <DatasubjectDatasubjectRightForm />
          </div>
        </right-panel>
      </template>
    </template>
    <!-- End : Inventory -->

    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          <span
            v-html="
              $t('datasubject.owned-list', {
                department: $options.filters.translate(breadCrumbs.process.department.name),
                process: $options.filters.translate(breadCrumbs.process.name),
                datasource: $options.filters.translate(breadCrumbs.datasource.name),
                data: $options.filters.translate(breadCrumbs.data.name),
              })
            "
          >
          </span>
        </span>

        <div v-if="recommendationAvailable" class="d-flex align-items-center float-right">
          <div class="d-flex align-items-center">
            <label class="switch-label">{{ $t("common.recommendations") }}</label>
            <b-form-checkbox v-model="showRecommendationBoxes" name="check-button" switch class="switch"></b-form-checkbox>
          </div>
        </div>
      </div>
      <div>
        <div class="search2  mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="text">{{ item.name | translate }}</div>
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>

            <div
              class="action"
              @click="fetchInfo(item.datasubject)"
              v-on:click.stop
              v-b-toggle="'sidebar-info-datasubject'"
              v-b-tooltip.hover
              :title="$t('datasubject.used-places')"
            >
              <i class="iconoir-info-circle"></i>
            </div>

            <div class="action" @click="edit(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>

            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>
        </div>

        <div class="ds-card--item2" @click="openRightPanel">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
      <recommendation-boxes
        v-if="parentEntity"
        :id="parentEntity._id"
        :show="showRecommendationBoxes"
        :level="libraryScopedState"
        :libraryScopedState="libraryScopedState"
        organizationScopedState="organizationDataDatasubject"
        @interceptForSetParent="interceptForSetParent"
        @onAccepted="paginate"
        @copyToForm="copyToForm"
      />
    </div>
  </div>
</template>

<script>
import BulkUpdateView from "@modules/inventory/component/bulk-update/bulk-update-view";
import DatasubjectDatasubjectRightForm from "@modules/inventory/component/datasubject-right/datasubject-datasubject-right-form";
import DatasubjectProcessingLegalForm from "@modules/inventory/component/processing/datasubject-legal-form";
import DatasubjectTransferingForm from "@modules/inventory/component/transfering/datasubject-transfering-form";
import Form from "../../data-datasubject/organization-data-datasubject-form";
import RecommendationBoxes from "./recommendation-boxes";

export default {
  components: { Form, RecommendationBoxes, DatasubjectTransferingForm, DatasubjectProcessingLegalForm, DatasubjectDatasubjectRightForm, BulkUpdateView },
  data() {
    return {
      request: {
        options: { page: 1, limit: 13, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      libraryScopedState: "datasubject",
      showRecommendationBoxes: undefined,

      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
      activeTab: null,
    };
  },
  computed: {
    recommendationAvailable() {
      const loading = this.$store.getters[`${this.libraryScopedState}/isLoading`];
      const recommendations = this.$store.getters[`${this.libraryScopedState}/recommendations`];

      if (loading) {
        return false;
      }
      if (recommendations && recommendations.docs && recommendations.docs.length > 0) {
        return true;
      }
      return false;
    },
    parentEntity() {
      return this.$store.getters["entityBoxes/data"];
    },
    breadCrumbs() {
      return {
        ...this.$store.getters["entityBoxes/data"],
        department: this.$store.getters["entityBoxes/department"],
        process: this.$store.getters["entityBoxes/process"],
        datasource: this.$store.getters["entityBoxes/datasource"],
      };
    },
    pagination() {
      return this.$store.getters["organizationDataDatasubject/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDataDatasubject/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },

    infoItem() {
      return this.$store.getters["organizationDatasubject/infoItem"];
    },
    info() {
      return this.$store.getters["organizationDatasubject/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationDatasubject/isInfoLoading"];
    },

    //inventory
    productInventoryStore() {
      return this.currentProduct == "GDPR" ? "gdprInventory" : "kvkkInventory";
    },
    datasubjectInventory() {
      const inventory = this.$store.getters[this.productInventoryStore + "/datasubjectInventory"];

      if (!inventory || !this.selectedBox?._id) return null;
      return inventory[this.selectedBox._id];
    },
    isDatasubjectInventoryLoading() {
      return this.$store.getters[this.productInventoryStore + "/isDatasubjectInventoryLoading"];
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/datasubject"];
    },
  },
  watch: {
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    parentEntity(item) {
      this.debounce(() => this.paginate());
    },

    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clearFrom", "datasubject");
      this.$store.commit("organizationDataDatasubject/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedDataSubject = this.$store.getters["entityBoxes/datasubject"];
        if (selectedDataSubject) {
          await this.selectBox(selectedDataSubject);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    selectedBoxStyle(item) {
      if (this.selectedBox?._id == item._id) {
        return "bg-main text-white";
      }
    },

    async paginate() {
      if (!this.parentEntity) {
        return;
      }
      const request = { ...this.request };
      request.query = {
        ...request.query,
        data: { value: { _id: this.parentEntity._id }, isObject: true },
      };

      await this.$store.dispatch("organizationDataDatasubject/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDataDatasubject/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    interceptForSetParent(payload) {
      payload.data = this.parentEntity;
    },

    async deleteByIdFromHierarchy(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDataDatasubject/delete", item.rel_id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.fetchInfo();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.delete-failed") });
      }
    },

    edit(item) {
      this.$store.commit("organizationDataDatasubject/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationDataDatasubject/editedEntity");
      this.$store.commit("organizationDataDatasubject/copingEntity");
      // this.$store.dispatch("organizationDataDatasubject/resetForm");
    },
    bulkUpdateRightPanelClosed() {
      this.$store.commit("inventoryFilter/clear");
    },
    selectBox(item) {
      this.$store.dispatch("entityBoxes/selectDatasubject", item);
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationDatasubject/fetchInfo", { item, pagination: this.infoRequest });
    },

    openRightPanel() {
      const data = this.$store.getters["entityBoxes/data"];
      this.$store.commit(`organizationDatasourceData/selectedEntity`, data);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject");
    },

    copyToForm(item) {
      this.$store.commit(`organizationDatasourceData/copingEntity`, { ...item, libraryItem: item, _id: undefined, data: this.parentEntity });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject");
    },

    //inventory
    onBulkUpdated() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-datasubject-inventory");
    },
    async inventoryRightPanelClosed() {
      const datasubjects = [{ _id: this.selectedBox._id }];
      await this.$store.dispatch(this.productInventoryStore + "/fetchDatasubjectInventory", { datasubjects });
      this.$store.commit("datasubjectProcessingLegal/showRecommendations", false);
      this.$store.commit("datasubjectTransfering/showRecommendations", false);
    },

    async showInventoryPanel(item) {
      this.$store.commit("entityBoxes/datasubject", item);
      this.$store.commit("organizationDataDatasubject/selectedEntity", item);

      this.$store.commit("inventoryFilter/clear");
      this.$store.commit("inventoryFilter/department", item.data.datasource.process.department);
      this.$store.commit("inventoryFilter/process", item.data.datasource.process);
      this.$store.commit("inventoryFilter/datasource", item.data.datasource);
      this.$store.commit("inventoryFilter/data", item.data);
      this.$store.commit("inventoryFilter/datasubject", item);

      const datasubjects = [item];

      this.$root.$emit("bv::toggle::collapse", "sidebar-datasubject-inventory");
      await this.$store.dispatch(this.productInventoryStore + "/fetchDatasubjectInventory", { datasubjects });
    },

    editDatasubjectTransfering(datasubject, transfering) {
      this.$store.commit("datasubjectTransfering/editedDatasubject", datasubject);
      this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", transfering);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-transfering");
    },
    createDatasubjectTransfering(datasubject) {
      this.$store.commit("datasubjectTransfering/editedDatasubject", datasubject);
      this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", null);

      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-transfering");
    },
    async deleteDatasubjectTransfering(datasubjectId, transferingId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasubjectTransfering/delete", transferingId);
        this.$store.commit(this.productInventoryStore + "/removeTransfering", { datasubjectId, transferingId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    editDatasubjectProcessingLegal(datasubject, processings) {
      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", datasubject);
      this.$store.commit("datasubjectProcessingLegal/editedDatasubjectProcessingLegal", processings);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-processing-legal");
    },
    createDatasubjectProcessingLegal(datasubject) {
      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", datasubject);
      this.$store.commit("datasubjectProcessingLegal/editedDatasubjectProcessingLegal", null);

      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-processing-legal");
    },
    async deleteDatasubjectProcessingLegal(datasubjectId, processingLegalId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasubjectProcessingLegal/delete", processingLegalId);
        this.$store.commit(this.productInventoryStore + "/removeProcessingLegal", { datasubjectId, processingLegalId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    addDatasubjectDatasubjectRight(item) {
      this.$store.commit("datasubjectDatasubjectRight/editedDatasubject", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasubject-datasubject-right");
    },

    async removeDatasubjectDatasubjectRigth(datasubjectId, datasubjectDatasubjectRightId) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("datasubjectDatasubjectRight/delete", datasubjectDatasubjectRightId);
        this.$store.commit(this.productInventoryStore + "/removeDatasubjectDatasubjectRigth", { datasubjectId, datasubjectDatasubjectRightId });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>

<style scoped>
.when-opened,
.when-closed {
  font-size: 20px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
